// Clic qu'un handler de lien ne doit PAS intercepter : `preventDefault()` sans cette garde confisque
// « ouvrir dans un nouvel onglet », « dans une fenêtre », le téléchargement et le clic molette.
export function isBrowserHandledClick (event: MouseEvent): boolean {
  return event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey;
}

export function redirectClickToOpener (event: MouseEvent): void {
  if (event.defaultPrevented || isBrowserHandledClick(event)) { return; }

  const anchor = (event.target as Element | null)?.closest('a[href]') as HTMLAnchorElement | null;
  if (!anchor || (anchor.target && anchor.target !== '_self')) { return; }

  const url = new URL(anchor.href);
  if (url.origin !== window.location.origin) { return; }

  const opener = window.opener;
  if (!opener || opener.closed) { return; }

  event.preventDefault();
  event.stopPropagation();
  try {
    opener.location.href = url.toString();
    opener.focus();
  } catch {
    window.location.href = url.toString();
  }
}
